// extracted by mini-css-extract-plugin
export default {"wrapper":"issues_wrapper__NH9kk","container":"issues_container__Xi5zG","box":"issues_box__9n77e"};